import React from 'react';

// const { buttonText } = this.buttonText;

export default props => <button type="button">{props.buttonText}</button>;
